<template>
  <div class="box">
    <div class="box-header">
      <h3>Post Period</h3>
    </div>
    <div class="box-body">
      <div class="grids is-4-desktop gap-20-desktop">
        <div class="field">
          <label for="" class="label">Period (Week) <span>*</span></label>
          <div class="control">
            <ValidationProvider name="Period" rules="required" v-slot="{ errors }">
              <input type="number" v-model="period" step="1" min="1" class="input" @change="periodKeychange"
                @input="filterInput(period)" />
              <span v-if="errors.length" style="color: red;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="field">
          <label for="" class="label">Post Date <span>*</span></label>
          <div class="control">
            <date-picker :disabled-date="notBeforeToday" type="date" v-model="form.openingDate" class="mt-1"
              valueType="date" :clearable="false" @change="periodKeychange" />
          </div>
        </div>
        <div class="field">
          <label for="" class="label">Close Date <span>*</span></label>
          <div class="control">
            <ValidationProvider name="Close Date" rules="required" v-slot="{ errors }">
              <date-picker type="date" v-model="form.closingDate" :disabled-date="notBeforeToday" class="mt-1"
                valueType="date" :clearable="false" :class="{ error: errors[0] }" />
              <span v-if="errors.length" style="color: red;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="field">
          <label for="" class="label">Expired Date <span>*</span></label>
          <div class="control">
            <ValidationProvider name="Expired Date" rules="required" v-slot="{ errors }">
              <date-picker type="date" v-model="form.expiredDate" :disabled="true" valueType="date" :clearable="false"
                :class="{ error: errors[0] }" />
              <span v-if="errors.length" style="color: red;">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
export default {
  components: {
    DatePicker
  },
  props: ["info"],
  data: () => ({
    form: {
      openingDate: null,
      closingDate: "",
      expiredDate: "",
    },
    period: null
  }),
  methods: {
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    filterInput(e) {
      if (!e.target) return
      e.target.value = e.target.value.replace(/[^0-9]+/g, "");
    },
    periodKeychange() {
      const isCheckDate = moment(this.form.openingDate).format("DD/MM/YYYY");
      const isDate = moment(new Date()).format("DD/MM/YYYY");
      if (isCheckDate > isDate) {
        this.form.expiredDate = moment(this.form.openingDate).add(
          7 * parseInt(this.period, 10), "days")._d;
        this.form.closingDate = moment(this.form.openingDate).add(
          7 * parseInt(this.period, 10), "days")._d;
      } else {
        this.form.expiredDate = moment(this.form.openingDate).add(
          7 * parseInt(this.period, 10), "days")._d;
        this.form.closingDate = moment(this.form.openingDate).add(
          7 * parseInt(this.period, 10), "days")._d;
      }
    },
    // disable select date
    notAfterDate(date) {
      this.form.expiredDate.setHours(0, 0, 0, 0);
      return date.getTime() > this.form.expiredDate.getTime();
    },
    notBeforeDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date.getTime() < today.getTime();
    },
  },

  watch: {
    form: {
      handler(val) {
        if (val) {
          this.$emit('input', val)
        }
      },
      immediate: true,
      deep: true
    },
    "info": {
      handler(val) {
        if (val) {
          this.form.openingDate = val.openingDate
          this.form.closingDate = val.closingDate
          this.form.expiredDate = val.expiredDate
          const d1 = moment(this.form.openingDate)
          const d2 = moment(this.form.expiredDate)
          const days = 24 * 60 * 60 * 1000 * 1
          const difference_ms = Math.abs(d1 - d2)
          const getDays = Math.floor(difference_ms / days) + 1
          this.period = Math.floor(getDays / 7)
          if (this.$route.query.repost === "repost") this.period = 1
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    setTimeout(() => {
      const d = new Date();
      this.form.openingDate = new Date(d.setHours(6, 0, 0, 0))
    });
  }
};
</script>

<style lang="scss" scoped>
.field {
  margin-bottom: 0;
}
</style>
